<template>
	<div class="edit_wrap">
		<!-- tab -->
		<div class="add_top">
			<div class="add_tab active_tab" @click="choiceTab">申请大V店已有品牌</div>
			<div class="add_tab" @click="addTab">添加新品牌</div>
		</div>
		<p align="center" class="main_word mt20" v-if="status==9">图书类复审驳回后不能修改品牌信息</p>
		<!-- 申请大V店已有品牌 -->
		<div class="choice_brand" v-show="isChoice">
			<!-- 搜索 -->
			<div class="add_search mt20 clearfix" v-if="status!=9">
				<el-button class="r ml10 mr20" type="primary" @click="keySearch">搜索</el-button>
				<el-input class="w325 r" v-model="brand_key" placeholder="输入品牌名称关键字，搜索大V店是否已有该品牌" @keyup.native.enter="keySearch"></el-input>
			</div>

			<!-- 中英文名称 -->
			<div class="add_name mt20">
				<div class="c_name">
					<span class="main_word mr4">*</span>
					品牌中文名称：
					<span v-if="!alSelect" class="main_word f12">根据您选择搜索到的大V店已有品牌，系统自动填充中文名称</span>
					<span v-else>{{ brandName }}</span>
				</div>
				<div class="e_name mt20">
					<span class="main_word mr4">*</span>
					品牌英文名称：
					<span v-if="!alSelect" class="main_word f12">根据您选择搜索到的大V店已有品牌，系统自动填充英文名称</span>
					<span v-else>{{ brandEnname }}</span>
				</div>
				<p class="f14 f666 mt20">如果没有找到你要申请的品牌，请添加品牌信息，审核通过后会将品牌信息录入大V店品牌库。</p>
			</div>
			<!-- 申请 保存 -->
			<div class="w150 auto mt120">

                <el-button v-if="status!=9" class="mr10" type="primary" @click="cancel">取消</el-button>

                <el-button v-if="status==9" class="mr10" type="primary" @click="goBack">返回</el-button>

				<el-button :disabled="status==9" type="primary" @click="save_choice">保存</el-button>
			</div>

			<!-- 搜索结果弹框 -->
			<el-dialog title="" :visible.sync="search_result" size="small">
			  <div class="wp100 tc">搜索结果如下，若没有您要的品牌，请【添加新品牌】</div>

			  <div class="mt20">
	  		  <el-radio-group class="radio_group" v-model="radio" @change="change_select">
	  	      <el-radio v-for="val in list" class="list_radio" :label="val.brandId" :key="val.brandId">{{ val.brandName }}</el-radio>
	  		  </el-radio-group>
			  </div>

			  <span slot="footer" class="dialog-footer">
			    <el-button @click="search_result = false">取 消</el-button>
			    <el-button :disabled="noSelect" type="primary" @click="sure_select">确 定</el-button>
			  </span>
			</el-dialog>
		</div>
		<!-- 添加新品牌 -->
		<div class="add_brand mt20" v-show="!isChoice">
			<el-form :model="addForm" :rules="rules" ref="addForm" label-width="200px" class="demo-ruleForm">
				<span class="ml90 f999">如果【申请大V店已有品牌】功能没有找到您要经营的品牌，请添加品牌信息，审核通过后会将品牌信息录入大V店品牌库：</span>
				<!-- 品牌中文名称 -->
				<el-form-item class="mt10" label="品牌中文名称：" prop="brandName">
			    <el-input :disabled="status==9" class="w250" v-model="addForm.brandName" placeholder="请输入品牌中文名称"></el-input>
			  </el-form-item>
			  <!-- 品牌英文名称 -->
			  <el-form-item label="品牌英文名称：" prop="brandEnname">
			    <el-input :disabled="status==9" class="w250" v-model="addForm.brandEnname" placeholder="请输入品牌英文名称"></el-input>
			  </el-form-item>
				<span class="ml200 f999">如果品牌没有中文名称或者英文名称，请在“中文名称”和“英文名称”输入相同的内容。</span>
			  <!-- 品牌介绍 -->
			  <el-form-item label="品牌介绍：" prop="brandDesc" class="dib mt20">
			    <el-input :disabled="status==9" class="w500" :autosize="{ minRows: 6, maxRows: 10}" type="textarea" v-model="addForm.brandDesc" placeholder="入驻品牌的介绍，品牌商品的卖点" :maxlength="200"></el-input>
			  </el-form-item>
			  <span class="word_num">您可以输入 <span class="main_word">{{ amount }}</span> 个字</span>
			  <!-- 重点商品 -->
			  <el-form-item label="重点商品：" prop="brandGoodsDesc">
			    <el-input :disabled="status==9" class="w500" :autosize="{ minRows: 6, maxRows: 10}" type="textarea" v-model="addForm.brandGoodsDesc" placeholder="重点商品介绍及线上链接，建议三款商品左右"></el-input>
			  </el-form-item>
			  <!-- 保存 -->
			  <el-form-item label-width="200px">

                  <el-button v-if="status!=9" class="mr10" type="primary" @click="cancel">取消</el-button>
				  <el-button v-if="status==9" class="mr10" type="primary" @click="goBack">返回</el-button>
                  <el-button :disabled="status==9" type="primary" @click="save_add('addForm')">保存</el-button>
		    </el-form-item>
			</el-form>
		</div>
		<!--搜索无内容弹框-->
		<el-dialog title="" :visible.sync="noDialog" size="tiny">
			<span>没有搜索到相关品牌，请[添加新品牌]</span>
			<span slot="footer" class="dialog-footer">
			<el-button type="primary" @click="noDialog = false">确 定</el-button>
		  </span>
		</el-dialog>

	</div>
</template>

<script type="text/javascript">
	export default {
		data () {
			return {
				status: 999,		// status=9时 复审驳回
				noSelect: true,			// 未选择品牌
				isChoice: true,				// tab 当前页面
				search_result: false,		// 搜索结果弹框
				noDialog: false,			// 无结果
				brand_key: '',			// 品牌关键字搜索radio: null,							// 选中的内容的 Id
                radio: null,							// 选中的内容
                supplierApplyId: 0,	// 申请id
                brandApplyId: 0,	// 品牌申请id
                registeredCountry: 0,	// 注册国家id
                brandId: 0,	// 品牌id
				brandName: '',	// 中文名称
				brandEnname: '',	// 外文名称
				alSelect: false,	// 已选择 品牌
				// 添加品牌数据
				addForm: {
					brandName: '',
					brandEnname: '',
					brandDesc: '',
					brandGoodsDesc: '',
				},
				// 搜索结果
				list: [
					{value:1,label:"xuan1"},
					{value:2,label:"xuan2"},
					{value:3,label:"xuan3"}
				],

				// 验证
				rules: {
                    brandName: [
						{ required: true, message: '请输入品牌中文名称', trigger: 'blur' }
					],
					brandEnname: [
						{ required: true, message: '请输入品牌英文名称', trigger: 'blur' }
					],
					brandDesc: [
						{ required: true, message: '请输入品牌介绍', trigger: 'blur' },
            			{ max: 200, message: '最多输入200个字', trigger: 'blur' }
					],
					brandGoodsDesc: [
						{ required: true, message: '请输入请输入重点商品链接', trigger: 'blur' }
					]
				}
			}
		},
		mounted () {
			this.$nextTick(function(){
				$('.el-dialog__footer').css('text-align','center');
				this.fetch();
			})
		},
		methods: {
			fetch () {
				var _this = this;
				var brandApplyId = this.$route.query.id;
                var supplierApplyId = this.$route.query.supplierApplyId;
                var registeredCountry = this.$route.query.registeredCountry;
                _this.brandApplyId = brandApplyId;
                _this.supplierApplyId = supplierApplyId;
                _this.registeredCountry = registeredCountry;
				if (brandApplyId == 0) {
					// 不处理
				} else {
					$.ajax({
						url: '/suppliers/supplierSettled/findSupplierApplyBrand',
						method: 'get',
						data: {
							brandApplyId: brandApplyId
						},
						success: function (result) {
							if (result.code==0) {
								_this.status = result.data.status;
								if (!result.data.brandId) {
                                    _this.initEditTab();
                                    _this.brandId = 0;
									_this.addForm.brandName = result.data.brandName;
									_this.addForm.brandEnname = result.data.brandEnname;
									_this.addForm.brandDesc = result.data.brandDesc;
									_this.addForm.brandGoodsDesc = result.data.brandGoodsDesc;
									_this.alSelect = false;
								} else {
                                    _this.brandId = result.data.brandId;
									_this.brandName = result.data.brandName;
									_this.brandEnname = result.data.brandEnname;
                                    _this.addForm.brandName = result.data.brandName;
                                    _this.addForm.brandEnname = result.data.brandEnname;
                                    _this.alSelect = true;
								}
							} else {
								_this.$message({
									message: result.msg,
									type: 'error'
								});
							}
						}
					})
				}
			},
			// 切换tab页
			choiceTab () {
                if (this.brandApplyId > 0) {
                    return;
                }
				this.isChoice = true;
				$('.add_tab:eq(0)').addClass('active_tab').siblings().removeClass('active_tab');
			},
			addTab () {
                if (this.brandApplyId > 0) {
                    return;
                }
				this.isChoice = false;
				$('.add_tab:eq(1)').addClass('active_tab').siblings().removeClass('active_tab');
			},
            initEditTab () {
                this.isChoice = false;
                $('.add_tab:eq(1)').addClass('active_tab').siblings().removeClass('active_tab');
            },
			// 搜索
			keySearch () {
				var _this = this;
				var brandName = this.brand_key;
                if (brandName) {
                    $.get({
                        url: '/suppliers/supplierSettled/findBrandByKeyword',
                        data: {
                            brandName: brandName
                        },
                        success: function (result) {
                            if (!result.code) {
                                _this.list = result.data.list;

                                if(_this.list.length == 0) {
                                    _this.noDialog = true;
                                } else {
                                    _this.search_result = true;
                                    _this.radio = null;
                                    _this.noSelect = true;
                                }
                            } else {
                                _this.$message({
                                    showClose: true,
                                    message: result.msg,
                                    type: 'error'
                                });
                            }
                        }
                    })
                } else {
                    this.$message({
                        showClose: true,
                        message: '请输入搜索内容',
                        type: 'error'
                    });
                }


			},
			change_select (val) {
				console.log(val)
				if (val) {
					this.noSelect = false;
				}
			},
			// 选中已选品牌
			sure_select () {
				var id = this.radio;
				for (var i=0 ;i <this.list.length;i++)
				{
					if (id == this.list[i].brandId) {
                        this.brandId = this.list[i].brandId;
						this.brandName = this.list[i].brandName;
						this.brandEnname = this.list[i].brandEnname;
						this.alSelect = true;
					}
				}
				this.search_result = false;
			},
			// 保存已选品牌
			save_choice () {
			    var _this = this;
				if (!this.brandName) {
                    this.$message.error('品牌中文名称不能为空');
                } else {
                    var data = {};
                    data.brandApplyId = _this.brandApplyId;
                    data.supplierApplyId = _this.supplierApplyId;
                    data.categoryIsBook = 1;
                    data.registeredCountry = _this.registeredCountry;
                    data.brandId = this.brandId;
                    data.brandName = this.brandName;
                    data.brandEnname = this.brandEnname;
                    $.ajax({
                        url: '/suppliers/supplierSettled/saveSupplierApplyBrand',
                        data: JSON.stringify(data),
                        dataType: "json",
                        contentType: 'application/json;charset=utf-8',
                        type: 'POST',
                        success: function (result) {
                            if (!result.code) {
                                _this.$message({
                                    message: '保存成功',
                                    type: 'success'
                                });
                                setTimeout(function () {
                                    _this.$router.push({
                                        path:'/edit_info_brand?supplierApplyId=' + _this.supplierApplyId
                                    })
                                },500)
                            } else {
                                _this.$message({
                                    message: result.msg,
                                    type: 'error'
                                });
                            }
                        }
                    })
                }
			},
			// 保存添加新品牌
			save_add(formName) {
			    var _this = this;
                this.$refs[formName].validate((valid) => {
                  if (valid) {
                     console.log('submit!');
                      var data = {};
                      data = JSON.parse(JSON.stringify(this.addForm));
                      data.brandApplyId = _this.brandApplyId;
                      data.supplierApplyId = _this.supplierApplyId;
                      data.categoryIsBook = 1;
                      data.registeredCountry = _this.registeredCountry;
                      data.brandId = 0;
                      //data.brandName = _this.addForm.brandName;
                      //data.brandEnname = _this.addForm.brandEnname;
                      //data.brandId = 0;
                      $.ajax({
                          url: '/suppliers/supplierSettled/saveSupplierApplyBrand',
                          data: JSON.stringify(data),
                          dataType: "json",
                          contentType: 'application/json;charset=utf-8',
                          type: 'POST',
                          success: function (result) {
                              if (!result.code) {
                                  _this.$message({
                                      message: '保存成功',
                                      type: 'success'
                                  });
                                  setTimeout(function () {
                                      _this.$router.push({
                                          path:'/edit_info_brand?supplierApplyId=' + _this.supplierApplyId
                                      })
                                  },500)
                              } else {
                                  _this.$message({
                                      message: result.msg,
                                      type: 'error'
                                  });
                              }
                          }
                      })
                  } else {
                    console.log('error submit!!');
                    return false;
                  }
                });
            },

            // 取消申请品牌
            cancel () {
			    var _this = this;
                this.$confirm('取消后系统将不保存您输入的品牌信息。', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$router.push({
                        path:'/edit_info_brand?supplierApplyId=' + _this.supplierApplyId
                    })
                }).catch(() => {
                    console.log("取消")
                });
            },
			goBack () {
            	var _this = this;
				this.$router.push({
					path:'/edit_info_brand?supplierApplyId=' + _this.supplierApplyId
				})
			}
		},
		computed: {
			amount: function () {
				return 200 - this.addForm.brandDesc.length;
			}
		}
	}

</script>

<style type="text/css" lang="less" scoped>
	.edit_wrap {
		width: 1050px;
	  // height: 4000px;
	  margin: 50px auto;
	  border: 1px solid #eee;
	  .add_top {
	  	width: 100%;
	  	height: 40px;
	  	background-color: #f9f9f9;
	  }
	  .add_tab {
	  	display: inline-block;
	  	width: 170px;
	  	height: 40px;
	  	text-align: center;
	  	line-height: 40px;
	  	color: #666;
	  	font-size: 14px;
	  	cursor: pointer;
	  }
	  .active_tab {
	  	border-bottom: 1px solid #ff4a7d;
	  	color: #ff4a7d;
	  }
	  .add_name {
	  	padding-left: 20px;
	  }
	}
	.choice_brand {
		min-height: 400px;
	}
	.w500 {
		width: 500px;
	}
	.w250 {
		width: 250px;
	}
	.w165 {
		width: 165px;
	}
    .w150 {
        width:150px;
    }
	.radio_group {
		width: 90%;
		padding-left: 15%;
		max-height: 150px;
		overflow-y: scroll;
	}
	.list_radio {
		margin-top: 10px;
		margin-left: 10%;
		width: 40%;
		overflow: hidden; 
		text-overflow:ellipsis; 
		white-space: nowrap;
	}
	.mt120 {
		margin-top: 120px;
	}
	.ml90 {
		margin-left: 90px;
	}
	.ml200 {
		margin-left:200px;
	}
	.el-radio + .el-radio {
     margin-left: 10%; 
	}
	.dialog-footer {
		text-align: center;
	}
	.w325 {
		width: 325px;
	}
</style>


// WEBPACK FOOTER //
// addBrand.vue?a465b47a